var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33334 8.99992H7.66668V10.3333H6.33334V8.99992ZM6.33334 3.66659H7.66668V7.66659H6.33334V3.66659ZM6.99334 0.333252C3.31334 0.333252 0.333344 3.31992 0.333344 6.99992C0.333344 10.6799 3.31334 13.6666 6.99334 13.6666C10.68 13.6666 13.6667 10.6799 13.6667 6.99992C13.6667 3.31992 10.68 0.333252 6.99334 0.333252ZM7.00001 12.3333C4.05334 12.3333 1.66668 9.94659 1.66668 6.99992C1.66668 4.05325 4.05334 1.66659 7.00001 1.66659C9.94668 1.66659 12.3333 4.05325 12.3333 6.99992C12.3333 9.94659 9.94668 12.3333 7.00001 12.3333Z",
    fill: "#DE1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMark);
export default __webpack_public_path__ + "static/media/error-mark.9370757de083265fb150ff5767a28971.svg";
export { ForwardRef as ReactComponent };